import React from 'react';
import { Route, Switch, BrowserRouter, useHistory } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';

import { ApolloProvider } from '@apollo/client';
import { Reset } from '@/shared/ui/core/reset';
import * as themes from '@/common/ui/theme';

import '@/common/phrases';
import '@/common/ui/css/petco-circular.css';
import '@/common/helpers/date/date';
import 'react-toastify/dist/ReactToastify.css';

import { ErrorBoundary } from './boundary';
import { activeRoutes } from './routes';
import { ConfigContext, ConfigProvider } from '../common/hooks/useConfigs';
import getApolloClient from './apollo';
import { GlobalStateProvider } from '@/common/hooks/useGlobalState';
import NewRelic from '@/shared/utils/NewRelic';

const RedesignApp = React.lazy(() => import('~/src/redesign/app'));

// FIXME: this should be removed as soon as the flag is ON in production
const forceLegacyUI = new URLSearchParams(window.location.search).get('legacy') === 'true';

function AppContent() {
  const history = useHistory();
  const [client] = React.useState(() => getApolloClient(history));

  return (
    <ThemeProvider theme={themes.petco}>
      <Reset />
      <ErrorBoundary>
        <ApolloProvider client={client}>
          <GlobalStateProvider>
            <ConfigProvider>
              <NewRelic />
              <ConfigContext.Consumer>
                {(configs) => (
                  configs.ENABLE_NEW_DVM_APP && !forceLegacyUI ? (
                    <React.Suspense>
                      <RedesignApp />
                    </React.Suspense>
                  ) : (
                    <Switch>
                      {activeRoutes(configs).map(({ component: Component, ...routeProps }) => (
                        <Route
                          {...routeProps}
                          key={routeProps.path}
                          render={(matchProps) => (
                            <React.Suspense>
                              <Component {...matchProps} />
                            </React.Suspense>
                          )}
                        />
                      ))}
                    </Switch>
                  )
                )}
              </ConfigContext.Consumer>
            </ConfigProvider>
          </GlobalStateProvider>
        </ApolloProvider>
      </ErrorBoundary>
    </ThemeProvider>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}
